import { Time as TimeScale } from '@antv/scale';
export const Time = (options) => {
    return new TimeScale(options);
};
Time.props = {};
//# sourceMappingURL=time.js.map